import React from 'react'

import { RequestContext } from 'src/lib/js/context'

const StaticSiteContext = React.createContext<RequestContext | undefined>(
  undefined
)

export const StaticSiteContextProvider = StaticSiteContext.Provider

export const useStaticSiteContext = () => React.useContext(StaticSiteContext)
